// Module
var code = `<div><p class="message center" translate="careers.thanks_for_applying_modal.message_other" translate-values="{ brandName: brandNameShort }" translate-compile></p><button type="button" class="modal-action-button blue" ng-click="action()" translate-once="careers.thanks_for_applying_modal.action"></button></div>`;
// Exports
export default code;